
export default {
  name: 'ProductInfoReviewsStars',
  props: {
    rating: {
      type: Number,
    },
    starColor: {
      type: String,
      default() {
        return this.$cp.black;
      },
    },
    starColorBoutique: {
      type: String,
      default() {
        return this.$cp.black;
      },
    },
    isBlack: {
      type: Boolean,
      default: false,
    },
    starWidth: {
      type: Number,
      default: 14,
    },
    starHeight: {
      type: Number,
      default: 14,
    },
  },
  computed: {
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
    starStyle() {
      return {
        fullStarColor: this.isBoutiquePage ? this.starColorBoutique : this.starColor,
        emptyStarColor: this.$cp.white,
        starWidth: this.starWidth,
        starHeight: this.starHeight,
      };
    },
  },
  data: () => ({
    starPoints: [
      7.032070403442383, 11.681161377716064,
      6.151475964422226, 12.144098989617824,
      5.269154417829514, 12.607944559848308,
      4.381885378866196, 13.074391078031063,
      3.5019051171875, 13.537005810546875,
      3.623489794983864, 12.615267624629736,
      3.794964244499207, 11.615503432435991,
      3.961280042366982, 10.645816229623557,
      4.132296364440918, 9.648723102493287,
      3.88883562335968, 8.727503562583923,
      3.1715287674714325, 8.026817610125542,
      2.4536196150234186, 7.327027603448032,
      1.740631438592076, 6.632034373393059,
      1.0161972657699585, 5.925884029846191,
      1.872461982832074, 5.74526917953968,
      2.8697307028884884, 5.600359634094238,
      3.8585056351773885, 5.456684290524125,
      4.845377582814216, 5.31328546283722,
      5.669085415649414, 4.830057671508789,
      6.11893088778019, 3.928121772571802,
      6.564923941955566, 3.0244443369293212,
      7.002376864457131, 2.1380710368978977,
      7.44846191745758, 1.2342071919345856,
      7.887630873599052, 1.9152031597340107,
      8.330461468162536, 2.8124727749729157,
      8.779296476783752, 3.7219086189174653,
      9.218590866508485, 4.612013125886917,
      9.91950044921875, 5.2715508203125,
      10.906168706297876, 5.422486835198403,
      11.896367701530458, 5.566368852119446,
      12.878596171164514, 5.70909270254612,
      13.8822847738266, 5.8549348425674435,
      13.435086531579495, 6.460780253272056,
      12.715628558434545, 7.162083144403099,
      11.99511162185669, 7.864418276672364,
      11.282914823055268, 8.558643224754332,
      10.841473107910156, 9.412368302955628,
      10.997273001039028, 10.404003267658949,
      11.16510883178711, 11.38263891784668,
      11.335334827040136, 12.375211402522773,
      11.505291252803802, 13.366212051725388,
      10.83231783667326, 13.18700836266279,
      9.939872044765949, 12.717837745583058,
      9.0567295819664, 12.25355801229477,
      8.178138905925751, 11.791671213817597,
      7.232793735351563, 11.601255078125,
    ],
  }),
};
